import React, { useEffect, useState } from "react";
import Quote from "../../Components/Quote";
import { Col, Container, Row } from "react-bootstrap";
import IframeMap from "./IframeMap";

const Iframe = () => {
  const [originAdd, setOriginAdd] = useState({
    lat: null,
    lng: null,
  });

  const [location, setLocation] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLocation({ latitude, longitude });
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);

  return (
    <>
      {/* <Container>
        <Row>
          <Col lg={6}>
            <Quote />
          </Col>
        </Row>
      </Container> */}
      <Container>
        <Row>
          <Col>
            <Quote />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Iframe;
